import React, { Suspense, useContext } from 'react';

import classname from '@search/classname/src';
import { errorCatcherWrap } from '@search/error/src/catcher';
import NewBuildingQuiz from '@search/nb-quiz/src/components/common/NewBuildingQuiz';
import QuizBuilder from '@search/nb-quiz/src/components/desktop/QuizBuilder';

import type { Shared } from '../../../../types/shared';
import Page from '../../../common/components/Page';
import ErrorBoundary from '../../../common/components/ErrorBoundary';
import { GlobalContext } from '../../../common/components/GlobalContext';

import './styles.css';

const cn = classname.bind(null, 'NewBuildingQuizPage');

const NewBuildingQuizWrapCatcher = errorCatcherWrap(NewBuildingQuiz);

const NewBuildingQuizPage = ({
    params
}: Shared.NewBuildingQuizPageProps) => {
    const globalContext = useContext(GlobalContext);
    const { rootRegions, quiz } = globalContext;

    return (
        <Page
            className={cn()}
            hasHeader={false}
            hasFooter={false}
        >
            <ErrorBoundary>
                <Suspense fallback=''>
                    {
                        params.id && quiz ? (
                            <QuizBuilder quiz={quiz} />
                        ) : (
                            <NewBuildingQuizWrapCatcher rootRegions={rootRegions} />
                        )
                    }
                </Suspense>
            </ErrorBoundary>
        </Page>
    );
};

NewBuildingQuizPage.displayName = 'NewBuildingQuizPage';

export default NewBuildingQuizPage;
